import { render } from "./ReceiptsUser.vue?vue&type=template&id=64a33931"
import script from "./ReceiptsUser.vue?vue&type=script&lang=js"
export * from "./ReceiptsUser.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__